import React, {Component} from 'react'
import fire from '../../../../../database/firebase'
import styled from 'styled-components'
import GridLoader from "react-spinners/GridLoader";
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/index.css';
import ClipLoader from "react-spinners/ClipLoader";

const Container = styled.div`
    width: 100%;
    height: auto;
    background-color: #321d05;
    //   padding: 1%;
    position: relative; /* Position relative to contain the dropdown */
    text-align: right;
    border-bottom: 0.5px solid white;
    padding-bottom: 2%;
`;

const Button = styled.button`
    background-color: #007bff;
    color: #fff;
    padding-left: 4%;
    padding-right: 4%;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 3.5%;
    background-color: #321d05;
    border-radius: 8px;
    border: 1px solid white;
    margin-top: 4%;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 100%; /* Position the dropdown below the button */
    left: 0;
    width: 96%; /* Expand the dropdown to the full width of the container */
    display: ${props => (props.open ? 'block' : 'none')}; /* Show/hide the dropdown */
    background-color: #321d05;
    color: #fff;
    padding: 10px;
    //   border: 0.7px solid white;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    font-family: sora;
    // border-bottom-left-radius: 10px;
    // border-bottom-right-radius: 10px;
    transition: max-height 0.3s ease-in, opacity 0.3s ease-in; /* Add transitions */
    max-height: ${props => (props.open ? '200px' : '0')}; /* Set max-height for smooth expansion and collapse */
    overflow: hidden; /* Hide overflow content */
    opacity: ${props => (props.open ? '1' : '0')}; /* Set opacity for fade-in and fade-out */
`;

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage {
    width: 100%;
    height: auto;
}

    // - - - NAVBAR - - //

.menu-btn {
    width: 25px;
    height: 25px;
}

    // - - - - - REWARDS PAGE - - - - - //

.rewardsPage {
    margin-top: 2.5%;
}

    // - - REWARDS PAGE HEADER - - //

.rewardsPageHeader {
    text-align: right;
}

.rewardsPageHeader h1 {
    margin-left: 2%;
    font-family: sora;
}

.rewardsPageHeader button {
    margin-right: 3.5%;
    width: 35%;
    background-color: #FF914D;
    color: #321d05;
    font-family: sora;
    font-size: 90%;
    padding: 2.5%;
    border-radius: 8px;
    border: 2px solid #FF914D
}

.rewardsPageHeader button:hover {
    // color: white;
    // background-color: #0930cb;
    // border: 2px solid #0930cb;
}

    // - - REWARDS PAGE LOADING - - //

.rewardsPageLoading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh; /* This will make the container take the full viewport height */
    text-align: center;
}

    // - - - - - UPCOMING REWARDS CONTAINER - - - - - - //

.upcomingRewardsContainer {
    margin-bottom: 10%;
}

.upcomingRewardsHeader h3 {
    margin-left: 5%;
    text-align: left;
    margin-top: 0px;
    // margin-left: 4%;
    font-family: arvo;
    color: #fff;
    padding-left: 3.5%;
    padding-right: 3.5%;
    padding-top: 2.25%;
    padding-bottom: 2.25%;
    border-radius: 12px;
}

.upcomingRewardsContent h3 {
    // font-family: sora;
    // color: #0930cb;
}  

    // - - REWARD DISPLAY - - //

.upcomingRewardDisplay {
    border-radius: 8px;
    width: 90%;
    height: auto;
    box-shadow: 2px 4px 8px 2px rgba(0, 0, 0, 0.10), 5px 6px 20px 5px rgba(0, 0, 0, 0.10);
}

.upcomingRewardDisplay:after {
    content: "";
    display: table;
    clear: both;
}

.rewardDisplayCol1 {
    float: left;
    width: 25%;
    text-align: center;
}

.rewardDisplayCol2 {
    float: left;
    width: 75%;
    text-align: left;
}

    // - REWARD DISPLAY COL 1 - //

.rewardDisplayCol1 h1 {
    margin-top: 25%;
    font-size: 43px;
    margin-bottom: 1%;
}

.rewardDisplayCol1 span {
    color: #321d05;
}

.rewardDisplayCol1 label {
    font-family: gabarito;
    color: #0930cb;
}

    // - REWARD DISPLAY COL 2 - //

.rewardDisplayCol2 p {
    margin-top: 3%;
    margin-bottom: 0px;
    margin-right: 2.5%;
    font-family: sora;
    font-size: 14px;
}

.rewardDisplayCol2 span {
    margin-top: 1.5%;
    background-color: #321d05;
    padding-left: 2.25%;
    padding-right: 2.25%;
    padding-top: 1.5%;
    padding-bottom: 1.5%;
    border-radius: 5px;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10), 0 6px 20px 0 rgba(0, 0, 0, 0.10);
}

.price-tag::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px 8px 0 8px;
    border-style: solid;
    border-color: #FF914D transparent transparent transparent;
}

.rewardDisplayCol2 h3 {
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
}

.rewardDisplayCol2 h4 {
    font-family: sora;
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
}

`

export default class RewardsSmPhone extends Component {
    constructor() {
        super() 
        this.state = {
            userID: "",
            phoneNumber: "",
            email: "",
            firstName: "",
            lastName: "",
            currentClient: "",
            placeholderText: "",
            showRewardsPage: false,
            showRewardsPageLoading: true,
            showRenderRewards: false,

            //* - - REWARDS - - *//

            points: 0,
            availableRewards: [],
            showRewardSelected: false,
            rewardHeader: "Redeem",
            rewardsArrayLoading: true,
            showDialogReward: false,
            showDialogRewardLoading: true,
            showDialogRewardSuccess: false,
            showDiscountPrice: true,
            showRedeemBtn: true,
            showRedeemBtnLoading: false,
            showRedeemConfirmBtns: false,
            rewardTitle: "",
            rewardPrice: "",
            discountPrice: "",
            rewardEmoji: "",
            rewardTag: "",
            rewardDate: "",
            rewardDateAndTime: "",
            rewardName: "",
            rewardType: "",
            rewardPointsValue: 0,
            customRewardValue: "",

            steakEmoji: "🥩",
            cocktailEmoji: "🍹",
            pizzaEmoji: "🍕",
                // BAKERY 
            croissantEmoji: "🥐",
            muffinEmoji: "🧁",
            cookieEmoji: "🍪",
            cakeEmoji: "🍰",
            pastryEmoji: "🥮",
            sausageEmoji: "🌭",
            specialBreadEmoji: "🥖",
            bagelEmoji: "🥯",
            regularBreadEmoji: "🍞",
            chocolateEmojit: "🍫",
            pieEmoji: "🥧",
                // END OF BAKERY

            beerEmoji: "🍺",

            avocadoEmoji: "🥑",
            eggEmoji: "🍳",
            waffleEmoji: "🧇",
            baconEmoji: "🥓",
            fruitEmoji: "🍍",
            bowlEmoji: "🥣",
            salmonEmoji: "🍣",

            burgerEmoji: "🍔",
            iceCreamEmoji: "🍨",
            chipsEmoji: "🍟",
            coffeeEmoji: "☕️",
            teaEmoji: "🫖",
            juiceEmoji: "🥤",
            icedDrinkEmoji: "🧋",
            chickenEmoji: "🍗",
            fishEmoji: "🍤",
            dishEmoji: "🥘",
            pastaEmoji: "🍝",
            wineEmoji: "🍷",
            liquorEmoji: "🥃",
            sandwichEmoji: "🥪",
            customRewardEmoji: "🎁",
        }
    }

    componentDidMount = () => {
        const url = window.location.href
        const parts = url.split('/'); // Split the URL by '/'
        const lastPart = parts[parts.length - 1]; // Get the last part
        this.setState({
            currentClient: lastPart
        })
        this.loadRewardsPage(lastPart)
        this.loadRewards()
    }

    loadRewardsPage = (client) => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                fire.firestore().collection("clients")
                .doc(client)
                .collection("members")
                .doc("members_list")
                .collection("email_list")
                .doc(user.email)
                .get().then(doc => {
                    if (doc.exists) {
                        this.setState({
                            userID: doc.data().id,
                            phoneNumber: doc.data().number,
                            email: user.email,
                        })
                        this.loadDatabaseInformation(client, doc.data().id)
                        this.loadPoints(doc.data().id)
                        this.loadUserName(doc.data().id)
                    }
                })
            } else {
                console.log("We failed dawg")
                this.setState({user:null})
            }
        })
        this.setState({
            showRewardsPageLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showRewardsPageLoading: false,
                showRenderRewards: true,
                showRewardsPage: true
               })
            }, 2500)
        })
    }

    loadUserName = (userID) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    firstName: doc.data().firstName,
                    lastName: doc.data().lastName
                })
            }
        })
    }

    loadPoints = (userID) => { 
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("pointsInfo")
        .get().then(doc => {
            this.setState({
                points: doc.data().points
            })
        })
    }

    loadDatabaseInformation = (client, userID) => {
        fire.firestore().collection("clients")
        .doc(client)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("rewards")
        .collection("list")
        .doc("placeholder")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    placeholderText: doc.data().text
                })
            }
        })
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
          isDropdownOpen: !prevState.isDropdownOpen,
        }));
    };

    exitRewardsPage = () => {
        this.setState({
            showRewardsPage: false,
            showRenderRewards: false,
            showRewardsPageLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showRewardsPageLoading: false,
               })
               window.location.href = `/home/${this.state.currentClient}`
            }, 2500)
        })
    }

    loadRewards = () => {
        class Reward {
            constructor(customRewardValue, date, dateAdded, expiryDate, freeItem, id, moneyEquivalentValue, moneyOffValue, newReward, percentageOffValue, pointsRewardValue, rewardMenuCategory, rewardMenuItem, rewardQuantity, rewardType) {
                this.customRewardValue = customRewardValue
                this.date = date
                this.dateAdded = dateAdded
                this.expiryDate = expiryDate
                this.freeItem = freeItem
                this.id = id
                this.moneyEquivalentValue = moneyEquivalentValue
                this.moneyOffValue = moneyOffValue
                this.newReward = newReward
                this.percentageOffValue = percentageOffValue
                this.pointsRewardValue = pointsRewardValue
                this.rewardMenuCategory = rewardMenuCategory
                this.rewardMenuItem = rewardMenuItem
                this.rewardQuantity = rewardQuantity
                this.rewardType = rewardType
            }
            toString () {
                return this.customRewardValue + ', ' +
                this.date + ', ' +
                this.dateAdded + ', ' +
                this.expiryDate + ', ' +
                this.freeItem + ', ' +
                this.id + ', ' +
                this.moneyEquivalentValue + ', ' +
                this.moneyOffValue + ', ' +
                this.newReward + ', ' +
                this.percentageOffValue + ', ' +
                this.pointsRewardValue + ', ' +
                this.rewardMenuCategory + ', ' +
                this.rewardMenuItem + ', ' +
                this.rewardQuantity + ', ' +
                this.rewardType + ', '
            }
        }
        var rewardConverter = {
            toFirestore:function(reward) {
                return {
                    customRewardValue: reward.customRewardValue,
                    date: reward.date,
                    dateAdded: reward.dateAdded,
                    expiryDate: reward.expiryDate,
                    freeItem: reward.freeItem,
                    id: reward.id,
                    moneyEquivalentValue: reward.moneyEquivalentValue,
                    moneyOffValue: reward.moneyOffValue,
                    newReward: reward.newReward,
                    percentageOffValue: reward.percentageOffValue,
                    pointsRewardValue: reward.pointsRewardValue, 
                    rewardMenuCategory: reward.rewardMenuCategory,
                    rewardMenuItem: reward.rewardMenuItem,
                    rewardQuantity: reward.rewardQuantity,
                    rewardType: reward.rewardType,
                }
            },
            fromFirestore:function(snapshot, options) {
                const data = snapshot.data(options)
                return new Reward(data.customRewardValue, data.date, data.dateAdded, data.expiryDate, data.freeItem, data.id, 
                data.moneyEquivalentValue, data.moneyOffValue, data.newReward, data.percentageOffValue, data.pointsRewardValue,
                data.rewardMenuCategory, data.rewardMenuItem, data.rewardQuantity, data.rewardType)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("rewards")
        .collection("rewardsList")
        .withConverter(rewardConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            // Remove the first element from the array
           
            const sortedArray = data.sort((a, b) => {
                const pointsA = parseInt(a.pointsRewardValue, 10);
                const pointsB = parseInt(b.pointsRewardValue, 10);
            
                return pointsA - pointsB;
            });
            this.setState({
                availableRewards: sortedArray,
                rewardsArrayLoading: false
            })
        })
    }

    isMoreThanThreeDaysApart = (dateString) => {
        // Convert the input date string to a Date object
        const inputDate = new Date(dateString);
        // Get the current date
        const currentDate = new Date();
        // Calculate the difference in milliseconds
        const timeDifference = Math.abs(inputDate - currentDate);
        // Calculate the difference in days
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        // Check if the difference is more than three days
        return daysDifference > 3;
    }

    renderRewards = () => {
        if (this.state.availableRewards.length !== 0) {
            const firstTenRewards = this.state.availableRewards.slice(0, 10);
            return firstTenRewards.map(rewards => {
                var {customRewardValue, date, dateAdded, expiryDate, freeItem, id,
                    moneyEquivalentValue, moneyOffValue, newReward, percentageOffValue, 
                    pointsRewardValue, rewardMenuCategory, rewardMenuItem,
                    rewardQuantity, rewardType} = rewards

                    if (this.state.rewardsArrayLoading) {
                         return (
                            <div style={{height: "20vh", textAlign: "center"}} className='upcomingRewardDisplay'>
                                <div style={{paddingTop: "12.5%"}}>
                                    <ClipLoader
                                    color="#321d05"
                                    loading={true}
                                    // cssOverride={override}
                                    size={25}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                            </div>
                         )
                    } else {

                        let rewardTitle
                        let rewardPrice

                        let discountPrice
                        let rewardTag

                        let rewardEmoji

                        let rewardStatusEmoji
                        let redeemBtnBgColor
                        let redeemBtnTxtColor
                        let priceTagBgColor 
                        let priceTagTxtColor
                        let showDiscountPrice = true

                        let newRewardLabel 

                        if (newReward === true && !this.isMoreThanThreeDaysApart(dateAdded)) {
                            newRewardLabel = true
                        }

                        if (rewardMenuItem !== "") {

                                //* - - REWARD LOCKED / UNLOCKED - - *//

                            if (this.state.points < parseInt(pointsRewardValue)) {
                                rewardStatusEmoji = "🔒"
                                redeemBtnBgColor = "#BDBDBD"
                                redeemBtnTxtColor = "#717070"
                                priceTagBgColor = "#BDBDBD"
                                priceTagTxtColor = "#717070"
                            } else {
                                rewardStatusEmoji = "🎉"
                                redeemBtnBgColor = "#0930cb"
                                redeemBtnTxtColor = "white"
                                priceTagBgColor = "#321d05"
                                priceTagTxtColor = "white"
                            }

                                //* - - REWARD EMOJI - - *//

                            if (rewardMenuCategory === "coffee_and_tea") {
                                rewardEmoji = this.state.coffeeEmoji
                            } else if (rewardMenuCategory === "breakfast") {
                                rewardEmoji = this.state.eggEmoji
                            } else if (rewardMenuCategory === "pasta") {
                                rewardEmoji = this.state.pastaEmoji
                            } else if (rewardMenuCategory === 'sandwiches') {
                                rewardEmoji = this.state.sandwichEmoji
                            } else if (rewardMenuCategory === "cocktails") {
                                rewardEmoji = this.state.cocktailEmoji
                            } else if (rewardMenuCategory === "burgers") {
                                rewardEmoji = this.state.burgerEmoji
                            } else if (rewardMenuCategory === "lunch_and_dinner") {
                                rewardEmoji = this.state.dishEmoji
                            }

                                //* - - REWARD DETAILS - - *//

                            const match = rewardMenuItem.split("(KES");
                            rewardTitle = match[0];
                            rewardPrice = `(KES${match[1]}`;

                            if (rewardType === "percentage-off") {
                                discountPrice = Math.round((parseInt(match[1]) - (parseInt(match[1]) * (parseInt(percentageOffValue)/100))) / 10) * 10 
                                rewardTag = `${percentageOffValue}% off`
                            } else if (rewardType === "amount-off") {
                                discountPrice = parseInt(match[1]) - parseInt(moneyOffValue);
                                rewardTag = `Save ${moneyOffValue}`
                            } else if (rewardType === "free-item") {
                                discountPrice = 0
                                rewardTag = `100% off`
                            }

                        } else {
                            if (this.state.points < parseInt(pointsRewardValue)) {
                                rewardStatusEmoji = "🔒"
                                redeemBtnBgColor = "#BDBDBD"
                                redeemBtnTxtColor = "#717070"
                                priceTagBgColor = "#BDBDBD"
                                priceTagTxtColor = "#717070"
                            } else {
                                rewardStatusEmoji = "🎉"
                                redeemBtnBgColor = "#0930cb"
                                redeemBtnTxtColor = "white"
                                priceTagBgColor = "#321d05"
                                priceTagTxtColor = "white"
                            }
                            rewardEmoji = this.state.customRewardEmoji
                            rewardTitle = customRewardValue
                            discountPrice = 0
                            showDiscountPrice = false
                            rewardTag = "Special Reward"
                        }

                        return (
                            <div style={{marginBottom: "4%", marginLeft: "5%", backgroundColor: "#f1f2f3"}} className='upcomingRewardDisplay'>
                                <div className='rewardDisplayCol1'>
                                {newRewardLabel && <span style={{marginLeft: "0px", backgroundColor: "#0930cb", fontSize: "10px", color: "white", marginTop: "30%", paddingLeft: "5%", paddingRight: "5%", paddingTop: "1.5%", paddingBottom: "1.5%", borderRadius: "8px", fontWeight: "bold"}}>NEW</span>}
                                    <h1 style={{marginTop: newRewardLabel === true ? "5%" : "25%"}}>{rewardEmoji}</h1>
                                    <span>
                                        <h5 style={{marginTop: "0px", marginBottom: "0px", fontWeight: "bolder", fontFamily: "sora"}}>Points:</h5>
                                    </span>
                                    <span>
                                        <h5 style={{marginTop: "0px", marginBottom: "0px", fontWeight: "bolder"}}>{pointsRewardValue}</h5>
                                    </span>
                                </div>
                                <div className='rewardDisplayCol2'>
                                    <p>{rewardTitle} <s>{rewardPrice}</s></p>
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        {showDiscountPrice && <span style={{backgroundColor: priceTagBgColor, marginRight: "2.5%"}}><h3 style={{color: priceTagTxtColor, fontFamily: "sora"}}>KES {discountPrice}</h3></span>}
                                        <span className='price-tag' style={{position: "relative", border: "2px solid #FF914D", backgroundColor: "#FF914D", borderRadius: "10px", paddingTop: "1%", paddingBottom: "1.5%", paddingLeft: "2.85%", paddingRight: "2.5%", display: "inline-block"}}><label style={{color: '#321d05', marginTop: "8%", marginBottom: "0px", fontFamily: "rubik", fontWeight: "normal"}}>{rewardTag}</label></span>
                                        <h3 style={{marginTop: "0px", marginBottom: "0px", fontSize: "", marginLeft: "2%", paddingTop: "2%"}}>{rewardStatusEmoji}</h3>
                                    </div>
                                    <div style={{marginTop: "4%", paddingBottom: "4%", display: "flex", flexDirection: "column"}}>
                                        <button 
                                        onClick={() => this.openRewardDialog(rewardTitle, rewardPrice, discountPrice, rewardEmoji, rewardTag, id, rewardType, pointsRewardValue, customRewardValue)}
                                        style={{width: "96.5%", height: "40px", fontFamily: "sora", color: redeemBtnTxtColor, borderRadius: "8px", border: `2px solid ${redeemBtnBgColor}`, fontSize: "80%", backgroundColor: redeemBtnBgColor}}
                                        >Redeem
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    
            })
        }
    }

    formatDate2 = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
    
        // Get the time (HH:MM)
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const returnTime = `${hours}:${minutes}:${seconds}`;
    
        return `${month}-${day}-${year} ${returnTime}`;
    };

    openRewardDialog = (rewardTitle, rewardPrice, discountPrice, rewardEmoji, rewardTag, id, rewardType, pointsRewardValue, customRewardValue) => {
        if (this.state.points < parseInt(pointsRewardValue)) {
            this.setState({
                showRewardSelected: true,
                showDialogRewardLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showDialogRewardLoading: false,
                        showDialogMissingPoints: true,
                    })
                }, 2000)
            })
        } else {
            this.setState({
                showRewardSelected: true,
                rewardTitle: rewardTitle,
                rewardPrice: rewardPrice,
                discountPrice: discountPrice,
                rewardEmoji: rewardEmoji,
                rewardTag: rewardTag,
                rewardDate: `${this.formatDate2(new Date()).slice(0, -3)}`,
                rewardDateAndTime: `${this.formatDate2(new Date())}`,
                rewardName: id,
                rewardType: rewardType,
                rewardPointsValue: parseInt(pointsRewardValue),
                customRewardValue: customRewardValue
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showDialogRewardLoading: false,
                        showDialogRewardSuccess: false,
                        showDialogReward: true
                    })
                }, 2000)
            })
        }
    }

    closeRewardDialog = () => {
        this.setState({
            showRewardSelected: false,
            showDialogRewardSuccess: false,
            showDialogMissingPoints: false,
            showDialogRewardLoading: true,
            showDialogReward: false
        })
    }

    closeRewardDialogSuccess = () => {
        this.setState({
            showRedeemConfirmBtns: false,
            showRedeemBtn: true,
            showDialogRewardSuccess: false,
            showDialogRewardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRewardSelected: false
                })
            }, 2000)
        })
    }

    closeRewardDialogMissingPoints = () => {
        this.setState({
            showDialogMissingPoints: false,
            showRewardSelected: false,
        })
    }

    redeemBtnClicked = () => {
        this.setState({
            showRedeemBtn: false,
            showRedeemBtnLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRedeemBtnLoading: false,
                    showRedeemConfirmBtns: true
                })
            }, 2000)
        })
    }

    cancelRedeemReward = () => {
        this.setState({
            showRedeemConfirmBtns: false,
            showRedeemBtnLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRedeemBtnLoading: false,
                    showRedeemBtn: true
                })
            }, 2000)
        })
    }

    pushDataToRewards = async () => {

        let orderDate = this.state.rewardDateAndTime.split(' ')[0];
        let timeDate = this.state.rewardDateAndTime.split(' ')[1];
        let components = orderDate.split('-');
        let timeComponents = timeDate.split(':');
        const newFormatOrderDate = `${components[0]}-${components[1]}-${components[2]}-${timeComponents[0]}-${timeComponents[1]}-${timeComponents[2]}`;

        let rewardID = `${this.state.userID}-${newFormatOrderDate}`;

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .doc(rewardID)
        .set({
            bgColor: "white",
            email: this.state.email,
            id: rewardID,
            name: `${this.state.firstName} ${this.state.lastName}`,
            userID: this.state.userID,   
            date: this.state.rewardDateAndTime, 
            rewardDiscountPrice: this.state.discountPrice,
            rewardName: this.state.rewardName,
            rewardType: this.state.rewardType,
            rewardValue: this.state.rewardTag.replace(/\D/g, ''),
            customRewardValue: this.state.customRewardValue,
            rewardPoints: this.state.rewardPointsValue
        })
        .then(async() => {
            const currentPointsRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("pointsInfo")

            await currentPointsRef.get().then(doc => {
                if (doc.exists) {
                    const currentPoints = doc.data().points
                    const updatedPoints = currentPoints - this.state.rewardPointsValue
                    currentPointsRef.update({
                        points: updatedPoints
                    })
                }
            })

            this.pointsListener = currentPointsRef.onSnapshot(doc => {
                if (doc.exists) {
                    const updatedPoints = doc.data().points;
                    this.setState({
                        points: updatedPoints
                    });
                }
            });
        })
    }

    confirmRedeemReward = async () => {
        this.setState({
            showDialogReward: false,
            showDialogRewardLoading: true
        }) 

        await this.pushDataToRewards()

        this.setState({
            showDialogRewardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showDialogRewardLoading: false,
                    showDialogRewardSuccess: true
                })
            }, 2000)
        })
    }

    render () {

        const titleStyle = {
            // Add your custom font properties here
            fontFamily: 'rubik',
            fontSize: '16px', // Adjust the font size as needed
            fontWeight: 'bold', // Adjust the font weight as needed
            color: "#321d05",
            paddingTop: "0.5%"
            // Add other font properties as needed
        };

        return (
            <Styles>
                <div className='fullPage'>
                    <div className='navbar'>
                        <Container>
                            <div style={{display: "flex", justifyContent:"space-between"}}>
                                <h3 style={{paddingLeft: "4%", fontFamily: "sora", fontSize: "18.5px", fontWeight: "bold", paddingTop: "2%", color: "white"}}>Rewards <label style={{marginLeft: "5px"}}></label></h3>
                                <Button onClick={this.toggleDropdown}>
                                    <img className='menu-btn' src='/assets/mobile-smallphone-menu-icon.png'/>
                                </Button>
                            </div>
                            <Dropdown open={this.state.isDropdownOpen}>
                            <p style={{paddingRight: "2.5%"}}>Logout</p>
                            <p style={{paddingRight: "2.5%"}}>Back to Home</p>
                            {/* <p style={{paddingRight: "2.5%"}}>Rewards</p>
                            <p style={{paddingRight: "2.5%"}}>More Options</p> */}
                            </Dropdown>
                        </Container>
                    </div>
                    {this.state.showRewardsPage && 
                        <div className='rewardsPage'>
                            <div className='rewardsPageHeader'>
                                {/* <h1>Challenges</h1> */}
                                <button
                                onClick={this.exitRewardsPage}
                                >Back to Home</button>
                            </div>
                        </div>
                    }
                    {this.state.showRenderRewards && 
                        <div style={{marginTop: "5%", marginBottom: "13.5%"}}>
                            <div className='renderRewardsHeader'>
                                <h2 style={{marginLeft: "5%", fontFamily: "arvo", marginTop: "0px"}}>Your Points: <label style={{fontFamily: "sora", color: "#0930cb"}}>{Math.round(this.state.points)}</label></h2>
                            </div>
                            {this.renderRewards()}
                        </div>
                    }
                    <Dialog
                    visible={this.state.showRewardSelected}
                    onClose={this.closeRewardDialog}
                    title={<div style={titleStyle}>{this.state.rewardHeader}</div>}
                    // style={{backgroundColor: "#f1f2f3"}}
                    >   {this.state.showDialogReward &&
                            <div>
                                <div>
                                    <p style={{marginTop: "0px", marginBottom: "0px", textAlign: "right", fontFamily: "sora", color: "#0930cb", fontWeight: "normal"}}>{this.state.rewardDate}</p>
                                    <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "1.5%", marginBottom: "0px"}}>How to redeem this reward:</h3>
                                    <p style={{fontFamily: "sora", fontSize: "95%", marginTop: "1%"}}>Before you redeem your reward, close this popup and re-open it in front of your server.</p>
                                </div>
                                <div>
                                    <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "1.5%", marginBottom: "1%"}}>Your Reward:</h3>
                                    <h1 style={{fontSize: "475%", marginBottom: "1%", marginTop: "1%", textAlign: "center"}}>{this.state.rewardEmoji}</h1>
                                    <p style={{fontFamily: "sora", marginTop: "1%", marginBottom: "0px", fontSize: "105%"}}>{this.state.rewardTitle} <s>{this.state.rewardPrice}</s></p>
                                    <div style={{display: "flex", flexDirection: "row", marginBottom: "2%", marginTop: "0.5%"}}>
                                        <h3 style={{marginTop: "2.75%", color: "#0930cb", fontWeight: "bold", marginRight: "1%", fontFamily: "gabarito", marginBottom: "0px"}}>PRICE: </h3>
                                        <h3 style={
                                            { 
                                                borderRadius: "7px",
                                                marginLeft: "2%",
                                                fontFamily: "sora", 
                                                backgroundColor: "#321d05", 
                                                color: "white", 
                                                marginTop: "1%", 
                                                display: "inline-block",
                                                paddingTop: "1.5%",
                                                paddingBottom: "1.5%",
                                                paddingLeft: "2.5%",
                                                paddingRight: "2.5%",
                                                marginBottom: "0px"
                                            }
                                            }>KES {this.state.discountPrice}</h3>
                                    </div>
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <h3 style={{marginTop: "1.5%", marginBottom: "0px", color: "#0930cb", fontWeight: "bold", marginRight: "1%", fontFamily: "gabarito"}}>DISCOUNT: </h3>
                                        <label style={{border: "2px solid #FF914D", backgroundColor: "#FF914D", color: "#321d05", marginTop: "0px", marginLeft: "2%", borderRadius: "10px", paddingTop: "1.5%", paddingBottom: "2%", paddingLeft: "2.5%", paddingRight: "2.5%", marginBottom: "0px"}}>{this.state.rewardTag}</label>
                                    </div>
                                    {this.state.showRedeemBtn && 
                                        <div style={{textAlign: "center", marginTop: "5%"}}>
                                            <button
                                            onClick={this.redeemBtnClicked}
                                            style={
                                                {
                                                    width: "70%",
                                                    backgroundColor: "#0930cb",
                                                    fontFamily: "sora",
                                                    paddingTop: "5%",
                                                    paddingBottom: "5%",
                                                    borderRadius: "30px",
                                                    color: "white",
                                                    fontSize: "100%",
                                                    border: "2px solid #0930cb"
                                                }
                                            }
                                            >Redeem</button>
                                        </div>
                                    }
                                    {this.state.showRedeemBtnLoading && 
                                        <div style={{textAlign: "center", marginTop: "5%"}}>
                                            <button
                                            style={
                                                {
                                                    width: "70%",
                                                    backgroundColor: "#0930cb",
                                                    fontFamily: "sora",
                                                    paddingTop: "5%",
                                                    paddingBottom: "5%",
                                                    borderRadius: "30px",
                                                    color: "white",
                                                    fontSize: "100%",
                                                    border: "2px solid #0930cb"
                                                }
                                            }
                                            >
                                                <ClipLoader
                                                color="#fff"
                                                loading={true}
                                                // cssOverride={override}
                                                size={15}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </button>
                                        </div>
                                    }
                                    {this.state.showRedeemConfirmBtns && 
                                        <div>
                                            <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "3%", marginBottom: "3%"}}>Confirm your choice:</h3>
                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                <button
                                                style={{
                                                    width: "35%", 
                                                    backgroundColor: "#dfdfdf",
                                                    border: "2px solid #dfdfdf", 
                                                    color: "red", 
                                                    borderRadius: "30px",
                                                    fontFamily: "sora",
                                                    padding: "3%",
                                                    fontSize: "95%"
                                                }}
                                                onClick={this.cancelRedeemReward}
                                                >Cancel</button>
                                                <button
                                                style={{
                                                    width: "35%", 
                                                    backgroundColor: "#0930cb", 
                                                    border: "2px solid #0930cb", 
                                                    color: "#fff", 
                                                    borderRadius: "30px",
                                                    fontFamily: "sora",
                                                    padding: "3%",
                                                    fontSize: "95%"
                                                }}
                                                onClick={this.confirmRedeemReward}
                                                >Confirm</button>
                                            </div>
                                            <div>
                                                
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {this.state.showDialogRewardLoading && 
                            <div style={{textAlign: "center", marginTop: "10%", marginBottom: "10%"}}>
                                <ClipLoader
                                color="#321d05"
                                loading={true}
                                // cssOverride={override}
                                size={30}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                                />
                            </div>
                        }
                        {this.state.showDialogRewardSuccess && 
                            <div>
                                <div style={{textAlign: "center"}}>
                                    <img style={{width: "20%"}} src='/assets/checkmark_publishedOffers3.png'/>
                                </div>
                                <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "3%", marginBottom: "3%", textAlign: "center"}}>You've successfully redeemed your reward.</h3>
                                <div style={{textAlign: "center", marginTop: "5%"}}>
                                    <button
                                    onClick={this.closeRewardDialogSuccess}
                                    style={
                                        {
                                            width: "70%",
                                            backgroundColor: "#321d05",
                                            fontFamily: "sora",
                                            paddingTop: "5%",
                                            paddingBottom: "5%",
                                            borderRadius: "30px",
                                            color: "white",
                                            fontSize: "100%",
                                            border: "2px solid #321d05"
                                        }
                                    }
                                    >Close</button>
                                </div>
                            </div>
                        }
                        {this.state.showDialogMissingPoints && 
                            <div style={{textAlign: "center"}}>
                                <div style={{textAlign: "center"}}>
                                    <img style={{width: "20%"}} src='/assets/smallPhone_missingPoints.png'/>
                                </div>
                                <h3 style={{fontFamily: "arvo", color: "#321d05", marginTop: "3%", marginBottom: "3%", textAlign: "center"}}>You don't have enough points to redeem this reward.</h3>
                                <div style={{textAlign: "center", marginTop: "5%"}}>
                                    <button
                                    onClick={this.closeRewardDialogMissingPoints}
                                    style={
                                        {
                                            width: "70%",
                                            backgroundColor: "#321d05",
                                            fontFamily: "sora",
                                            paddingTop: "5%",
                                            paddingBottom: "5%",
                                            borderRadius: "30px",
                                            color: "#fff",
                                            fontSize: "100%",
                                            border: "2px solid #321d05"
                                        }
                                    }
                                    >Close</button>
                                </div>
                            </div>
                        }
                    </Dialog>
                    {this.state.showRewardsPageLoading && 
                        <div className='rewardsPageLoading'>
                            <GridLoader
                            color="#321d05"
                            loading={true}
                            // cssOverride={override}
                            size={7.5}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}